import React from 'react';
import LoadingIndicator from '../LoadingIndicator';
import styles from './LoadingSpinner.module.scss';
export const LoadingSpinner = ({ loading }) => (<div className={styles.loadingSpinnerContainer}>
    <div className={styles.centered}>
      <LoadingIndicator loading={loading} size='large'/>
    </div>
  </div>);
